module.exports = {"320582100":"杨舍镇","320582101":"塘桥镇","320582102":"金港镇","320582103":"锦丰镇","320582104":"乐余镇","320582105":"凤凰镇","320582106":"南丰镇","320582107":"大新镇","320582400":"张家港市现代农业示范园区","320582401":"张家港经济技术开发区","320582403":"张家港保税区","320582404":"张家港市市稻麦良种场","320582405":"张家港市畜禽良种场","320582406":"张家港市冶金工业园","320582407":"双山岛旅游度假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320582.json
// module id = 872
// module chunks = 0